import { forwardRef } from 'react'
import { IconProps } from 'almanac-ui/icons/Types'

export const LineHeight = forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', size = 16 }, forwardedRef) => {
    return (
      <svg
        width={size}
        height={size}
        style={{ width: size, height: size }}
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        ref={forwardedRef}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.9499 5.0134C10.7731 5.22554 10.8018 5.54082 11.0139 5.71761C11.226 5.89439 11.5413 5.86573 11.7181 5.65359L12.084 5.21452V10.4525L11.7181 10.0134C11.5413 9.80127 11.226 9.7726 11.0139 9.94939C10.8018 10.1262 10.7731 10.4414 10.9499 10.6536L12.1999 12.1536C12.2949 12.2676 12.4356 12.3335 12.584 12.3335C12.7324 12.3335 12.8731 12.2676 12.9681 12.1536L14.2181 10.6536C14.3949 10.4414 14.3662 10.1262 14.1541 9.94939C13.942 9.7726 13.6267 9.80127 13.4499 10.0134L13.084 10.4525V5.21452L13.4499 5.65359C13.6267 5.86573 13.942 5.89439 14.1541 5.71761C14.3662 5.54082 14.3949 5.22554 14.2181 5.0134L12.9681 3.5134C12.8731 3.39941 12.7324 3.3335 12.584 3.3335C12.4356 3.3335 12.2949 3.39941 12.1999 3.5134L10.9499 5.0134ZM1.99902 4.3335C1.99902 4.05735 2.22288 3.8335 2.49902 3.8335H9.50121C9.77735 3.8335 10.0012 4.05735 10.0012 4.3335C10.0012 4.60964 9.77735 4.8335 9.50121 4.8335H2.49902C2.22288 4.8335 1.99902 4.60964 1.99902 4.3335ZM2.49902 7.5C2.22288 7.5 1.99902 7.72386 1.99902 8C1.99902 8.27614 2.22288 8.5 2.49902 8.5L9.50121 8.50001C9.77735 8.50001 10.0012 8.27615 10.0012 8.00001C10.0012 7.72386 9.77736 7.50001 9.50121 7.50001L2.49902 7.5ZM2.49902 11.167C2.22288 11.167 1.99902 11.3909 1.99902 11.667C1.99902 11.9431 2.22288 12.167 2.49902 12.167H9.50121C9.77735 12.167 10.0012 11.9431 10.0012 11.667C10.0012 11.3909 9.77735 11.167 9.50121 11.167H2.49902Z"
          fill={color}
        />
      </svg>
    )
  },
)

export default LineHeight
